
import React, {Fragment} from "react";
import MomentUtils from "@date-io/moment";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import moment from "moment";

moment.updateLocale("en", {week: {dow: 1}});
const DateSelector = props => {
  let initialValue; //= moment().startOf('day');
  if (props.value && props.value !== "")
    initialValue = moment(props.value);
  else if (props.initialValue)
    initialValue = moment(props.initialValue);
  else if (props.emptyValue)
    initialValue = moment(props.emptyValue);
  else if (props.minDate)
    initialValue = moment(props.minDate);
  else if (props.defaultValue)
    initialValue = moment(props.defaultValue);

  // Strip time from date
  let initialValueDay = null;
  if (initialValue && initialValue._isAMomentObject && initialValue._isValid) {
    initialValueDay = moment(initialValue.parseZone().startOf('day'));
  }
  const [originalInitialValue, setOriginalInitialValue] = React.useState(initialValueDay?initialValueDay:initialValue);
  const [selectedDate, setSelectedDate] = React.useState(initialValueDay?initialValueDay:initialValue);

  if (originalInitialValue?.format() !== (initialValueDay?initialValueDay:initialValue)?.format()) {
    setSelectedDate(initialValueDay?initialValueDay:initialValue);
    setOriginalInitialValue(initialValueDay?initialValueDay:initialValue);
  }

  const handleDateChange = (date) => {
    if (date) {
      setSelectedDate(date);
      //using parseZone to prevent timezone conversion resulting in wrong date
      props.onChange(date.parseZone().toISOString(true));
    } else {
      setSelectedDate(date);
      if (props.returnInvalidDate) {
        props.onChange(null);
      }
    }
  };

  /**
   * Disabled - see comment below about rifmFormatter
   */
  // const dateFormatter = str => {
  //   return str;
  // };
  return (
    <Fragment>
      <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
        <KeyboardDatePicker
          disabled={props.disabled || false}
          style={{...props.style}}
          variant="inline"
          disableToolbar={props.disableToolbar || false}
          autoOk={props.autoOk || false}
          format={props.format || "DD/MM/YYYY"}
          // mask={props.mask || "__/__/____"} // Using default masking from format
          // maskChar={props.maskChar || '_'} // Using default masking from format
          fullWidth={props.fullWidth}
          label={props.label || undefined}
          emptyLabel={props.emptyLabel || undefined}
          minDate={props.minDate || undefined}
          maxDate={props.maxDate || new Date('9999-12-31T23:59:59Z')}
          value={selectedDate || null}
          onChange={handleDateChange}
          InputAdornmentProps={{ position: "start" }}
          KeyboardButtonProps={{
            size: 'small',
            color: 'primary'
          }}
          placeholder={props.format || "DD/MM/YYYY"}
          readOnly={props.readOnly || false}
          InputProps={{readOnly: props.readOnly, ...props.InputProps}}
          invalidDateMessage={props.invalidDateMessage || undefined}
          onError={props.onError || undefined}
//          rifmFormatter={dateFormatter} // This causes issues - needs more in depth look if we choose to use, possibly need regexp here
        />
      </MuiPickersUtilsProvider>
    </Fragment>
  )
};

export default DateSelector;
